import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Settings } from '@material-ui/icons';
import { CircularProgress } from '@material-ui/core';
import { GridCellParams } from '@material-ui/data-grid';
import ActionsMenuComponent from 'components/ActionsMenu';
import { FORM_MODE } from 'shared/enums';
import {
  showMailingRuleAction,
  inactivateMailingRuleAction,
} from 'modules/mailingRule';
import { openAlert } from 'modules/alertHandler';
import { RootState } from 'store';
import { REQUEST_LIFE_CICLE } from 'interfaces/requests';

const ActionsMenu = (
  params: GridCellParams,
  {
    inactivateAction,
    showAction,
    updateAction,
  }: { inactivateAction: boolean; showAction: boolean; updateAction: boolean },
): JSX.Element => {
  const [isRequesting, setIsRequesting] = useState(false);
  const dispatch = useDispatch();
  const handleShowMailingRule = (mailingRuleId: string, mode: FORM_MODE) => {
    dispatch(showMailingRuleAction({ id: mailingRuleId, mode }));
    setIsRequesting(true);
  };

  const { loading: mailingRuleLoading } = useSelector(
    (state: RootState) => state.mailingRule,
  );

  useEffect(() => {
    if (isRequesting) {
      setIsRequesting(!isRequesting);
    }
  }, [mailingRuleLoading, isRequesting]);

  const handleInactivateMailingRule = (id: string) => {
    dispatch(
      openAlert({
        title: 'Inativar a Régua de Mailing?',
        content:
          'Inativando a Régua de Mailing, ela não poderá ser mais editada.',
        primaryButton: 'Sim',
        primaryButtonAction: inactivateMailingRuleAction(id),
      }),
    );
  };

  const items = [];

  if (showAction) {
    items.push({
      label: 'Visualizar',
      onClick: () =>
        handleShowMailingRule(params.row.id.toString(), FORM_MODE.view),
    });
  }

  if (params.row.status !== 'inactive' && updateAction) {
    items.push({
      label: 'Editar',
      onClick: () =>
        handleShowMailingRule(params.row.id.toString(), FORM_MODE.edit),
    });
  }

  if (params.row.status === 'active' && inactivateAction) {
    items.push({
      label: 'Inativar',
      onClick: () => handleInactivateMailingRule(params.row._id),
    });
  }

  return mailingRuleLoading === REQUEST_LIFE_CICLE.PENDING && isRequesting ? (
    <CircularProgress />
  ) : (
    <ActionsMenuComponent actionItems={items} icon={Settings} />
  );
};

export default ActionsMenu;
